import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'
import {UpmFilter} from '@refra/modules/refra-flexible-report/types'

export const useUpmGlobalStructureQuery = (filters: UpmFilter[]) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'upmGlobalStructure',
    params: [{filters}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useUpmGlobalStructureQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching kiln nodes')

      spawnErrorToast(t('error.upmGlobalStructure'))

      return false
    }
  })
}
